import { useQuery } from '@tanstack/react-query';
import { opportunityApiConnect } from '../../../lib/api/opportunityApi.connect';
/**
 * Hook to fetch a single opportunity by noticeId.
 * Used when navigating into a related opportunity from the Similar tab.
 */ export function useOpportunity(noticeId) {
    return useQuery({
        queryKey: [
            'opportunities',
            'detail',
            noticeId
        ],
        queryFn: ()=>{
            if (!noticeId) throw new Error('noticeId is required');
            return opportunityApiConnect.getOpportunity(noticeId);
        },
        enabled: !!noticeId,
        staleTime: 5 * 60 * 1000
    });
}
